import { getStudioIntegrationLessonConfigDetail } from '../../../api/studioIntegrationConfigsApi'
import StudioIntegrationLessonConfigDescriptions from '../../../components/studio-integration-configs/studio-integration-lesson-config-descriptions/studio-integration-lesson-config-descriptions'
import { IStudioIntegrationLessonConfig } from '../share-types'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const StudioIntegrationLessonConfig = () => {
  const params = useParams()
  const [lessonConfigId] = useState<string | undefined>(params?.lessonConfigId)
  const [studioIntegrationLessonConfig, setStudioIntegrationLessonConfig] =
    useState<IStudioIntegrationLessonConfig>()

  useEffect(() => {
    if (lessonConfigId) {
      getStudioIntegrationLessonConfigDetail(Number(lessonConfigId)).then(data => {
        setStudioIntegrationLessonConfig(data)
      })
    }
  }, [lessonConfigId])

  return (
    <>
      <Space style={{ width: '100%' }} orientation="vertical" size={16}>
        {studioIntegrationLessonConfig && (
          <>
            <StudioIntegrationLessonConfigDescriptions data={studioIntegrationLessonConfig} />
          </>
        )}
      </Space>
    </>
  )
}

export default StudioIntegrationLessonConfig
